import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=ca27016a&scoped=true&"
import script from "./ClientInfo.vue?vue&type=script&lang=ts&"
export * from "./ClientInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ClientInfo.vue?vue&type=style&index=0&id=ca27016a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca27016a",
  null
  
)

export default component.exports